var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MembershipEditor',_vm._g(_vm._b({attrs:{"add-member-dialog-name":"AddClusterMemberDialog","default-binding-handler":_vm.defaultBindingHandler,"type":_vm.NORMAN.CLUSTER_ROLE_TEMPLATE_BINDING,"mode":_vm.mode,"parent-key":"clusterId","parent-id":_vm.parentId}},'MembershipEditor',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }